import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
} from "@mui/material";
import { exportToPDFGeneric } from "../../utils/ExportPDFGeneric";
import { exportToPDFGeneral } from "../../utils/ExportPDFGenericGeneral";
import ScappSwitch from "../../utils/ScappSwitch";

const ExportMenuGeneric = ({ chartInstanceRef, invert, allLabels, toggleLabels ,dialogOpen, setDialogOpen, setLoadingPDF, setProgressPDF, translate }) => {
  const t = (key, fallback) => {
    const value = typeof translate === "function" ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const [darkModePDF, setDarkModePDF] = useState(false);

  // ðŸ‘‡ NUEVO
  const [generalChart, setGeneralChart] = useState(false);

  const handleExportGeneric = async () => {
    try {
      setLoadingPDF(true);
      setProgressPDF(0);
      setDialogOpen(false); // cerrar de inmediato

      const chart = chartInstanceRef.current;
      const visibleLabels =
        chart?.data?.datasets
          ?.map((ds, i) => (chart.isDatasetVisible(i) ? ds.label : null))
          ?.filter(Boolean) || [];

      const metricResolver = (dsLabel) => {
        const hit = (toggleLabels || []).find((t) => t.label === dsLabel);
        return hit ? { metricName: hit.label, unit: hit.unit } : { metricName: dsLabel };
      };

      if (!generalChart) {
        await exportToPDFGeneral(chart, {
          darkModePDF,
          title: `${toggleLabels[0].label} / ${toggleLabels[1].label}`,
          invert,
          fileName: "Reporte.pdf",
          onProgress: (p) => setProgressPDF(p), // ðŸ‘ˆ IMPORTANTE
        });
      } else {
        await exportToPDFGeneric(chart, {
          darkModePDF,
          title: `${toggleLabels[0].label} / ${toggleLabels[1].label}`,
          invert,
          respectVisibility: true,
          visibleDatasetLabels: visibleLabels,
          fileName: "Reporte_por_metrica.pdf",
          metricResolver,
          rowsPerTable: 9,
          maxColsPerPage: 5,
          allLabels,
          onProgress: (p) => setProgressPDF(p), // ðŸ‘ˆ IMPORTANTE
        });
      }

      // opcional: asegurarte de pintar 100% un instante
      setProgressPDF(100);
    } finally {
      setLoadingPDF(false);
    }
  };


  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        PaperProps={{
          sx: {
            bgcolor: '#0c0c0c !important',
            color: "#e6e6e6",
            border: "0.01vw solid #e94e1a",
            borderRadius: ".4vw",
            minWidth: '15vw',
            boxShadow: 'none',
          },
        }}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0)" } },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            letterSpacing: 0.2,
            borderBottom: "0.01vw solid #e94e1a",
            pb: "1vh",
            bgcolor: '#0c0c0c !important',
          }}
        >
          {t('export_options', 'Opciones de exportacion')}
        </DialogTitle>

        <DialogContent sx={{  display: "grid", gap: "1.2rem", bgcolor: '#0c0c0c !important', }}>
          <FormControlLabel
            sx={{ ".MuiFormControlLabel-label": { color: "#cbd5e1", fontWeight: 500 }, gap: ".5vw", marginTop:'1vh' }}
            control={
              <ScappSwitch
                isChecked={darkModePDF}
                onToggle={(e, checked) => setDarkModePDF(typeof checked === "boolean" ? checked : e.target.checked)}
                inputProps={{ "aria-label": t('dark_mode_pdf', 'Modo oscuro PDF') }}
              />
            }
            label={t('dark_mode_pdf', 'Modo oscuro PDF')}
          />

          {/* ðŸ‘‡ NUEVO: selector de grÃ¡fico general */}
          <FormControlLabel
            sx={{ ".MuiFormControlLabel-label": { color: "#cbd5e1", fontWeight: 500 }, gap: ".5vw" }}
            control={
              <ScappSwitch
                isChecked={generalChart}
                onToggle={(e, checked) => setGeneralChart(typeof checked === "boolean" ? checked : e.target.checked)}
                inputProps={{ "aria-label": t('separate_metrics', 'Separar metricas') }}
              />
            }
            label={t('separate_metrics', 'Separar metricas')}
          />
        </DialogContent>

        <DialogActions sx={{ borderTop: "1px solid #e84e0e", p: 2, gap: 1, bgcolor: '#0c0c0c !important', }}>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
          >
            {t('cancel', 'Cancelar')}
          </Button>
          <Button variant="contained" onClick={handleExportGeneric}
            sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", border:'solid 0.01vw #e84e0e', "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
          >
            {t('generate_pdf', 'Generar PDF')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExportMenuGeneric;


